import { Filter } from '../../../../../types';

export const defaultFilter = (): Filter => ({ label: '', query: '*' });
